import { Routes } from '@angular/router';
import {
  ExecutionOfTrafficOrganizationProjectsComponent
} from './execution-of-traffic-organization-projects/execution-of-traffic-organization-projects.component';
import { AuthGuard } from '../../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../../guards/is-completed-user-data.guard';
import {
  ProvidingInformationAboutTravelConditionsComponent
} from './providing-information-about-travel-conditions/providing-information-about-travel-conditions.component';

export const createExternalApplicationsRoutes: Routes = [
  {
    component: ExecutionOfTrafficOrganizationProjectsComponent,
    path: 'e-uslugi/wykonanie-projektow-organizacji-ruchu',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: ProvidingInformationAboutTravelConditionsComponent,
    path: 'e-uslugi/udostepnienie-informacji-o-warunkach-przejazdu',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];

export const editExternalApplicationsRoutes: Routes = [
  {
    component: ExecutionOfTrafficOrganizationProjectsComponent,
    path: 'wnioski-robocze/wykonanie-projektow-organizacji-ruchu/:appId',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  // {
  //   component: ProvidingInformationAboutTravelConditionsComponent,
  //   path: 'wnioski-robocze/udostepnienie-informacji-o-warunkach-przejazdu/:appId',
  //   canActivate: [AuthGuard, IsCompletedUserDataGuard]
  // }
];
